import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/site/Logo";

export const PaymentSuccess = () => {
  const [state, setState] = useState("checking");
  const sessionId = new URLSearchParams(window.location.search).get("session_id");
  useEffect(() => {
    if (!sessionId) { setState("error"); return undefined; }
    let tries = 0;
    const t = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); clearInterval(t); }
        else if (tries >= 8) { setState(data.payment_status === "failed" ? "failed" : "pending"); clearInterval(t); }
      } catch { if (tries >= 8) { setState("error"); clearInterval(t); } }
    }, 2500);
    return () => clearInterval(t);
  }, [sessionId]);
  const txt = { paid: ["Paiement reçu. Merci !", "Le Maître a été informé de votre règlement. Votre travail se poursuit dans le chat."],
    pending: ["Paiement en cours de confirmation", "La confirmation bancaire peut prendre quelques instants. Revenez dans le chat, tout est enregistré."],
    failed: ["Paiement refusé", "Votre banque a refusé le paiement. Vous pouvez réessayer quand vous voulez."],
    error: ["Nous n'avons pas retrouvé ce paiement", "Vérifiez dans le chat avec le Maître si le paiement est bien passé."],
    checking: ["Vérification du paiement...", ""] }[state];
  const Icon = state === "paid" ? CheckCircle2 : state === "checking" ? Loader2 : XCircle;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0908] px-5 text-center" data-testid="payment-status-page">
      <Logo size={64} />
      <Icon className={`mt-8 h-14 w-14 ${state === "paid" ? "text-emerald-400" : state === "checking" ? "animate-spin text-amber-300" : "text-red-400"}`} data-testid="payment-status-icon" />
      <h1 className="mt-6 font-display text-2xl text-amber-50">{txt[0]}</h1>
      {txt[1] && <p className="mt-3 max-w-sm text-sm text-stone-300">{txt[1]}</p>}
      <Link to="/" className="mt-10 rounded-full bg-amber-400 px-8 py-3 text-sm font-bold uppercase tracking-wider text-stone-950" data-testid="payment-back-home">
        Retour au site
      </Link>
    </div>
  );
};

export const PaymentCancel = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0908] px-5 text-center" data-testid="payment-cancel-page">
    <Logo size={64} />
    <h1 className="mt-8 font-display text-2xl text-amber-50">Paiement annulé</h1>
    <p className="mt-3 max-w-sm text-sm text-stone-300">Aucun montant n'a été prélevé. Rappelez : vous ne payez qu'après satisfaction totale.</p>
    <Link to="/" className="mt-10 rounded-full bg-amber-400 px-8 py-3 text-sm font-bold uppercase tracking-wider text-stone-950" data-testid="payment-cancel-home">
      Retour au site
    </Link>
  </div>
);
